export default __webpack_public_path__ + "static/media/protest-alt.019df02d.jpg";